import React, { useState } from "react";
import { useQuery } from "react-query";
import DataTable from "../../../components/shared/DataTable";
import Pagination from "../../../components/shared/Pagination";
import { formatDate, statusBadgeClass } from "../../../utils/helpers";
import api from "../../../utils/api";

export default function BookingHistory() {
  const [page, setPage] = useState(1);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const { data, isLoading } = useQuery(
    ["patient-booking-history", page, dateFrom, dateTo],
    () =>
      api.get(
        `/patient/bookings?page=${page}&from=${dateFrom}&to=${dateTo}`
      ),
    { keepPreviousData: true }
  );

  const columns = [
    { key: "type", label: "Type" },
    { key: "doctorOrLabName", label: "Doctor / Lab", sortable: true },
    {
      key: "scheduledAt",
      label: "Date",
      render: (row) => formatDate(row.scheduledAt, "dd MMM yyyy, hh:mm a"),
      sortable: true,
    },
{ key: "forName", label: "Patient Name", render: (row) => row.forName || "Self" },
    {
      key: "status",
      label: "Status",
      render: (row) => (
        <span className={statusBadgeClass(row.status)}>{row.status}</span>
      ),
    },
  ];

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-3 items-end">
        <div>
          <label className="block text-xs font-semibold text-slate-500 mb-1 uppercase tracking-wide">From</label>
          <input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} className="input-field" />
        </div>
        <div>
          <label className="block text-xs font-semibold text-slate-500 mb-1 uppercase tracking-wide">To</label>
          <input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} className="input-field" />
        </div>
      </div>
      <DataTable
        columns={columns}
        data={data?.bookings || []}
        loading={isLoading}
        emptyMessage="No booking history yet."
      />
      <Pagination page={page} totalPages={data?.totalPages || 1} onPageChange={setPage} />
    </div>
  );
}
